import request from '@/utils/request'

const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API

/**
 * 单车认证进度查询
 * @yapi http://yapi.cusc.com:3000/project/28/interface/api/8632
 */
export const querySearchProgress = data => {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}search/carProgress`,
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js